import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { domainKeys } from '@/shared/lib/query/queryKeys';

import type { DomainItem } from '@/entities/domain';

import { getDomainDetailApi } from '@/features/domain/api';

type UseDomainDetailOptions = {
  enabled?: boolean;
};

export const useDomainDetail = (domainFqn: string | null, options?: UseDomainDetailOptions) => {
  const { enabled = true } = options || {};

  return useQueryWithBoundary<DomainItem>({
    queryKey: domainKeys.detail(domainFqn || ''),
    queryFn: () => getDomainDetailApi(domainFqn!),
    enabled: !!domainFqn && enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
    retry: false,
  });
};
